import { render, staticRenderFns } from "./VersionActionContent.vue?vue&type=template&id=444ae389&"
import script from "./VersionActionContent.vue?vue&type=script&lang=ts&"
export * from "./VersionActionContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports